import {
    apiRequest,
    LocationCreate
} from "../../../../../services/adapters/master/locationPresenceService"

class CreateRepository {

    fetchCreate = async (query) => {
        return await apiRequest("post", LocationCreate, {
            body: query
        }, true)
    }

}

export default CreateRepository